import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import EliteMindUsersTable from './EliteMindUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyEliteMindUsers } from './companyEliteMindApi';

/**
 * Company Elite Mind → Athletes list.
 * Every user of the current population appears (those with no sport profile
 * show dashes and sort last); a row opens their athlete profile.
 */
const CEliteMindUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyEliteMindUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Elite Mind — {isB2BFansMode ? 'Members' : 'Athletes'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your athletes, their journal activity and the reports they have chosen to share. Journal
        entries are counted, never read, and a report kept private is not shown anywhere.
      </p>

      <EliteMindUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/elite-mind/user?userId=${rowData?._id}`)}
        tableName="company_elite_mind_users"
      />
    </div>
  );
};

export default CEliteMindUsers;
